import React from 'react';
import { SlCalender } from "react-icons/sl";
import VideoPlayer from "../../utils/vidioPlayer";
import sejarahVideo from "../../assets/video/sejarah2025.mp4";
export default function Content() {
    const videoJsOptions = {
        controls: true,
        autoplay: false,
        responsive: true,
        fluid: true,
        sources: [{
            src: sejarahVideo,
            type: 'video/mp4',
        }],
    };

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 p-5 md:p-5 lg:p-16">
            <span className="text-xl font-poppinsBold text-center flex justify-center mb-5">PROFIL</span>

            <div className="mt-4">
                <div className="font-poppinsRegular">
                    <b className='text-2xl text-bprBlue'>BPR Palu Anugerah (BPA)</b>
                    <p className="text-gray-500 mt-2">
                        <b>BPR Palu Anugerah</b> yang sebelumnya dikenal sebagai Bank Perkreditan Rakyat, kini telah berganti nama menjadi Bank Perekonomian Rakyat. Sebagai lembaga keuangan yang memiliki beragam produk, BPR Palu Anugerah berkomitmen untuk memberikan solusi keuangan yang sesuai dengan kebutuhan masyarakat, terutama bagi pelaku UMKM dan masyarakat kecil. Fungsi utama kami adalah menghimpun dana dari masyarakat dalam bentuk tabungan dan deposito, serta menyalurkan dana tersebut kembali kepada masyarakat dalam bentuk pinjaman atau kredit. Kami berkomitmen untuk mendukung pertumbuhan ekonomi lokal dan memberdayakan UMKM di sekitar kami dengan menyediakan layanan keuangan yang mudah diakses dan tepat guna.
                    </p>

                </div>
            </div>

            {/* Timeline Section */}
            <div className="mt-16">
                <div className="relative">
                    {/* Timeline items */}
                    <div className="flex flex-col md:grid grid-cols-9 mx-auto font-poppinsRegular">
                        {/* Item 1 */}
                        <div className="flex flex-row-reverse md:contents">
                            <div className="w-full md:w-2/3 bg-white p-6 rounded-lg shadow-md col-start-1 col-end-5 my-4 ml-auto">
                                <h3 className="font-bold text-lg mb-1">Awal</h3>
                                <time className="text-sm text-gray-400 mb-2 block">Pada tanggal 12 Mei 1990</time>
                                <p className="text-gray-600">
                                Sebelum BPR Palu Anugerah berdiri, Bapak Yoepy Gunawan (Alm.) bersama dua rekannya, Bapak Paulus Suryatika (Alm.) dan Bapak Tjondro, mendirikan BPR Purwosari Anugerah dengan Akta Pendirian No. 126 di hadapan Notaris Indrawati Setiabudhi, SH.
                                </p>
                            </div>
                            <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
                                <div className="h-full w-6 flex items-center justify-center">
                                    <div className="h-full w-0.5 bg-bprDarkBlue pointer-events-none"></div>
                                </div>
                                <div className="w-6 h-6 absolute top-1/2 -mt-3 bg-bprDarkBlue rounded-full shadow flex items-center justify-center">
                                    <SlCalender className="text-white text-sm" />
                                </div>
                            </div>
                        </div>

                        {/* Item 2 */}
                        <div className="flex md:contents">
                            <div className="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                                <div className="h-full w-6 flex items-center justify-center">
                                    <div className="h-full w-0.5 bg-bprDarkBlue pointer-events-none"></div>
                                </div>
                                <div className="w-6 h-6 absolute top-1/2 -mt-3 bg-bprDarkBlue rounded-full shadow flex items-center justify-center">
                                    <SlCalender className="text-white text-sm" />
                                </div>
                            </div>
                            <div className="w-full md:w-2/3 bg-white p-6 rounded-lg shadow-md col-start-6 col-end-10 my-4 mr-auto">
                                <h3 className="font-bold text-lg mb-1">Berdiri</h3>
                                <time className="text-sm text-gray-400 mb-2 block">Pada tanggal 4 April 2006</time>
                                <p className="text-gray-600">
                                    Setelah pendirian BPR Purwosari, Bapak Yoepy Gunawan melanjutkan visinya dengan mendirikan BPR Palu Anugerah. BPR Palu Anugerah resmi berdiri berdasarkan Akta Pendirian No. 02 yang dibuat oleh Notaris Bapak Adnan Umar Adnan, SH., MH.
                                </p>
                            </div>
                        </div>

                        {/* Item 3 */}
                        <div className="flex flex-row-reverse md:contents">
                            <div className="w-full md:w-2/3 bg-white p-6 rounded-lg shadow-md col-start-1 col-end-5 my-4 ml-auto">
                                <h3 className="font-bold text-lg mb-1">Perkembangan dan relokasi</h3>
                                <time className="text-sm text-gray-400 mb-2 block">Pada tanggal 13 Februari 2013</time>
                                <p className="text-gray-600">
                                    Setelah mengalami pertumbuhan yang pesat, BPR Palu Anugerah kemudian pindah ke lokasi baru di Jl. Basuki Rahmat No. 86, Kota Palu, dari sebelumnya yang beralamat di Jl. Emmy Saelan No. 17, Kota Palu.
                                </p>
                            </div>
                            <div className="col-start-5 col-end-6 md:mx-auto relative mr-10">
                                <div className="h-full w-6 flex items-center justify-center">
                                    <div className="h-full w-0.5 bg-bprDarkBlue pointer-events-none"></div>
                                </div>
                                <div className="w-6 h-6 absolute top-1/2 -mt-3 bg-bprDarkBlue rounded-full shadow flex items-center justify-center">
                                    <SlCalender className="text-white text-sm" />
                                </div>
                            </div>
                        </div>

                        {/* Item 4 */}
                        <div className="flex md:contents">
                            <div className="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                                <div className="h-full w-6 flex items-center justify-center">
                                    <div className="h-full w-0.5 bg-bprDarkBlue pointer-events-none"></div>
                                </div>
                                <div className="w-6 h-6 absolute top-1/2 -mt-3 bg-bprDarkBlue rounded-full shadow flex items-center justify-center">
                                    <SlCalender className="text-white text-sm" />
                                </div>
                            </div>
                            <div className="w-full md:w-2/3 bg-white p-6 rounded-lg shadow-md col-start-6 col-end-10 my-4 mr-auto">
                                <h3 className="font-bold text-lg mb-1">Ekspansi dan Pencapaian</h3>
                                <time className="text-sm text-gray-400 mb-2 block">Pada tahun 2006 - sekarang</time>
                                <p className="text-gray-600">
                                    Sejak tahun 2006 hingga saat ini, BPR Palu Anugerah telah mencatatkan pencapaian penting dalam perjalanannya dengan membuka empat cabang dan dua kantor kas di berbagai lokasi. Ekspansi ini tidak hanya mencerminkan komitmen dalam pelayanan keuangan, tetapi juga sebagai bukti keberhasilan dan pertumbuhan pesat.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-10">
                <VideoPlayer options={videoJsOptions} />
            </div>
        </div>
    );
}